export enum PurchaseOrderStatus {
  Draft = 'draft',
  Generated = 'generated',
  Cancelled = 'cancelled',
  DeliveryNote = 'deliveryNote',
  Invoice = 'invoice',
}
